import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeChecker } from '@attain-apps/type-guards'

import type * as models from '../../models'

export type Name = ec.Name.Dynamic<`${typeof Name.PREFIX}${string}-${string}`>

export namespace Name {
  export const isName: TypeChecker<Name> = TypeChecker.Factory.custom(
    (name): name is Name =>
      TypeChecker.isString(name) &&
      ec.Name.Dynamic.isDynamic(name) &&
      name.replace(`${ec.Name.Dynamic.PREFIX}`, '').startsWith(PREFIX),
    { typeDescription: 'Collection.Name' },
  )

  export const PREFIX = 'widget-'

  /**
   * Identifies a widget collection whose name contains the supplied reference
   * ID. Generated modal, slideout, and preview references cannot be resolved
   * through their full widget identifier, but retain this ID in their name.
   */
  export function isForReference(
    name: string,
    reference: models.widget.Ref,
  ): name is Name {
    return isName(name) && name.endsWith(`-${reference.id}`)
  }

  /**
   * Creates a collection name that is unique for a widget reference and its
   * widget definition. The reference ID is only positional within a page, so
   * using it by itself causes different pages with the same layout to reuse
   * persisted current-list parameters.
   */
  export function from({ id, widget }: models.widget.Ref): Name {
    const widgetIdentifier = widget.id ?? widget.alias
    if (widgetIdentifier === undefined) {
      throw new Error('Widget reference must contain an ID or alias')
    }

    return ec.Name.Dynamic.from(`${PREFIX}${widgetIdentifier}-${id}`)
  }
}
